module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fst1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("“I’d like to talk to you about your husband Joey.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Mary Jo stepped outside, curious. She perched on one side of the wooden railing. Amy, on the opposite rail, sat a few feet away. In the marina behind the house, light waves on the bay rippled softly as a boat cruised by.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s this about?” Mary Jo asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s not every day that I confront a wife,” Amy began, “but your husband, Joey, is having an affair with my sixteen-year-old sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mary Jo was taken aback. “Really?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Look,” Amy said, “I have proof.” She held up the T-shirt in her left hand. It bore the logo of Joey’s auto body shop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mary Jo shrugged. “Joey gives these shirts to a lot of people,” she said, standing up. “That doesn’t prove anything. Listen, I’m going to go in and call Joey now. Thanks for coming by to see me.” She turned and reached for the door handle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was not the reaction Amy Fisher had expected. Suddenly fury engulfed the young girl. Withdrawing the automatic pistol hidden deep inside her pants pocket, Amy raised it to eye level, and pointed it at Mary Jo’s right temple. Then she pulled the trigger.…")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27645da5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 66
// module chunks = 0